import { Action } from '@ngrx/store';

import { User } from '®shared/auth';
import { ListItem } from '®shared/reading-list/models';

import { RequestDigitisationIdentifier } from './request-digitisation-identifier';

export enum RequestDigitisationActionTypes {
  OPEN_REQUEST_DIGITISATION_URL = '[Request digitisation] open Request digitisation URL',
  OPEN_REQUEST_DIGITISATION_IDENTIFIER_PICKER = '[Request digitisation] open Request digitisation identifier picker',
  SELECT_REQUEST_DIGITISATION_IDENTIFIER = '[Request digitisation] select identifier',
  SHOW_REQUEST_DIGITISATION_MODAL = '[Request digitisation] show modal',
  HIDE_REQUEST_DIGITISATION_MODAL = '[Request digitisation] hide modal',
  CANCEL_REQUEST_DIGITISATION = '[Request digitisation] cancel digitisation request for item',
  COMPLETE_REQUEST_DIGITISATION = '[Request digitisation] complete digitisation request for item',
}

export enum RequestDigitisationFinishedReason {
  CANCELLED = 'cancel',
  COMPLETED = 'close',
}

export interface ItemPayload {
  item: ListItem;
}

export interface RequestDigitisationUrlPayload extends ItemPayload {
  requestDigitisationUrl: string;
}

export interface RequestDigitisationPayload extends ItemPayload {
  user: User;
}

export interface SelectRequestDigitisationIdentifierPayload
  extends RequestDigitisationPayload {
  selectedIdentifier: RequestDigitisationIdentifier;
}

export interface HideRequestDigitisationModalPayload extends ItemPayload {
  reason: RequestDigitisationFinishedReason;
  listId: string;
}

export interface CompleteRequestDigitisationPayload extends ItemPayload {
  listId: string;
}

export class OpenRequestDigitisationUrlAction implements Action {
  readonly type = RequestDigitisationActionTypes.OPEN_REQUEST_DIGITISATION_URL;

  constructor(public payload: RequestDigitisationUrlPayload) {}
}

export class OpenRequestDigitisationIdentifierPickerAction implements Action {
  readonly type =
    RequestDigitisationActionTypes.OPEN_REQUEST_DIGITISATION_IDENTIFIER_PICKER;

  constructor(public payload: RequestDigitisationPayload) {}
}

export class SelectRequestDigitisationIdentifierAction implements Action {
  readonly type =
    RequestDigitisationActionTypes.SELECT_REQUEST_DIGITISATION_IDENTIFIER;

  constructor(public payload: SelectRequestDigitisationIdentifierPayload) {}
}

export class ShowRequestDigitisationModalAction implements Action {
  readonly type =
    RequestDigitisationActionTypes.SHOW_REQUEST_DIGITISATION_MODAL;

  constructor(public payload: RequestDigitisationPayload) {}
}

export class HideRequestDigitisationModalAction implements Action {
  readonly type =
    RequestDigitisationActionTypes.HIDE_REQUEST_DIGITISATION_MODAL;

  constructor(public payload: HideRequestDigitisationModalPayload) {}
}

export class CancelRequestDigitisationAction implements Action {
  readonly type = RequestDigitisationActionTypes.CANCEL_REQUEST_DIGITISATION;
}

export class CompleteRequestDigitisationAction implements Action {
  readonly type = RequestDigitisationActionTypes.COMPLETE_REQUEST_DIGITISATION;

  constructor(public payload: CompleteRequestDigitisationPayload) {}
}

export type RequestDigitisationOpenActions =
  | OpenRequestDigitisationUrlAction
  | OpenRequestDigitisationIdentifierPickerAction;

export type RequestDigitisationCloseActions =
  | CancelRequestDigitisationAction
  | CompleteRequestDigitisationAction;

export type RequestDigitisationActions =
  | OpenRequestDigitisationUrlAction
  | OpenRequestDigitisationIdentifierPickerAction
  | SelectRequestDigitisationIdentifierAction
  | ShowRequestDigitisationModalAction
  | HideRequestDigitisationModalAction
  | CancelRequestDigitisationAction
  | CompleteRequestDigitisationAction;
